import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { MultiSelectMobile } from '../MultiSelectMobile';
import { MultiSelectDesktop } from '../MultiSelectDesktop';
import { useControlledValue } from '../../internal';

/**
 * Адаптивный select-компонент для выбора нескольких значений из списка
 *
 * * Десктопный вариант открывает выпадающий список
 * * Мобильный вариант открывает список в модальном окне
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var MultiSelect = /*#__PURE__*/React.forwardRef(function MultiSelect(props, ref) {
  var deviceType = useDeviceType();
  var _useControlledValue = useControlledValue(props, []),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  if (deviceType === 'phone') {
    return /*#__PURE__*/_jsx(MultiSelectMobile, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      value: value,
      onChange: onChange
    }));
  }
  return /*#__PURE__*/_jsx(MultiSelectDesktop, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    value: value,
    onChange: onChange
  }));
});